import { useMutation, useQueryClient } from "@tanstack/react-query";
import { hasVerifiedSession, verifyUserEmail } from "../../apis/user";
import { commitLoginSession } from "./session";

type VerifyEmailParams = {
  token: string;
  email: string;
  /** Ask the backend to sign the user in on a consuming verification. */
  login?: boolean;
};

export function useVerifyEmail() {
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ token, email, login }: VerifyEmailParams) => {
      return verifyUserEmail(token, email, { login });
    },
    // Same contract as useLogin: a reply that carries a session is the session.
    // Web and native both send `login` from the verify step and the email link.
    onSuccess: (data) => {
      if (hasVerifiedSession(data)) {
        commitLoginSession(queryClient, data);
      }
    },
  });

  return {
    verifyUserEmail: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
